<template>
  <div class="version">
    {{ COMMIT_HASH }}
  </div>
</template>

<script lang="js">
export default {
  name: "VersaoLabel",

  data() {
    return {
      COMMIT_HASH: COMMIT_HASH,
    };
  },
};
</script>

<style lang="css" scoped>
.version {
  position: fixed;

  color: #fff;
  bottom: 5px;
  right: 10px;
  font-weight: bold;
  font-size: 16px;
}
</style>



// WEBPACK FOOTER //
// src/components/VersaoLabel.vue